export const AUTH_CONFIG = {
  refreshTokenEndpoint: 'bx_block_login/logins/refresh_token',

  accessTokenKey: 'token',
  refreshTokenKey: 'refresh_token',
  cometAuthTokenKey: 'comet_auth_token',
  profileKey: 'profile',

  loginRouteWithReason: '/EmailAccountLoginBlock?reason=session_expired',
  tokenErrorMessages: ['Invalid token', 'Token has Expired'],
};
